<template>

    <b-modal v-model="display" size="lg">

        <template #modal-title>
            <div>
                <h4>{{ item.plan | uppercase }}</h4>
                <div>{{ item.fecha_pedido | humanizar_fecha_simple | uppercase }}</div>
            </div>
        </template>

        <template #modal-footer="{ cancel, ok, close }">
            <b-button @click="close()">Cerrar</b-button>
            <!-- <b-button variant="success" @click="saveChanges()">Guardar</b-button> -->
        </template>

        <div class="modalPlanAgendaDetails">
            <!-- bloqueo de fecha: {{ item.fecha_pedido | humanizar_fecha_simple }} | ItemPlanID: {{item.plan_id}} -->
            <LimitePlan :plan-id="item.plan_id" :fecha="item.fecha_pedido" :debug="debug"  @updated="$emit('updated')" />
            <br />
            <cocinareporteinterrelacion-quicktable hide-plan-name :args="{
                fechaPedido: item.fecha_pedido,
                planesId: item.plan_id
            }" />
            <div v-if="debug" class="debug">
                <pre>{{ item }}</pre>
            </div>
        </div>

    </b-modal>

</template>

<script>

import CocinareporteinterrelacionQuicktable from '../Cocinareporteinterrelacion/CocinareporteinterrelacionQuicktable.vue';
import LimitePlan from '../Easylunch/elements/limite-plan.vue';

export default {
    name: 'modalPlanAgendaDetails',

    components: { CocinareporteinterrelacionQuicktable, LimitePlan },

    props: {
        debug: {
            type: Boolean,
            default: false
        }
    },

    data: () => {
        return {
            item: null,
            display: null
        }
    },

    methods: {
        filterByPlan(item) {
            this.item = item
            this.display = true;
        }
    }
}

</script>

<style lang="less">
.modalPlanAgendaDetails {}
</style>